let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("1hiqo")]).then(() => parcelRequire('8NiE4'));